<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Order Payment Transfer">
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog1" v-model="modal" :return-value.sync="fromDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="From Date" v-model="fromDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="fromDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog1.save(fromDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-dialog ref="dialog" v-model="modal1" :return-value.sync="toDate" persistent width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field label="To Date" v-model="toDate" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="toDate" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal1 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
                OK
              </v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
      </v-row>
      <v-card-actions>
          <router-link :to="{ name: 'nodalView' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table
        v-model="checkedRows"
        sort-by
        hide-default-footer
        :single-select="singleSelect"
        show-select
        :items-per-page="-1"
        :headers="headers"
        :items="tableData"
        :search="search"
        :single-expand="true"
        show-expand
        item-key="index"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Order Payment Transfer</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pb-4 pt-4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      Installment Amount
                    </th>

                    <th class="text-center">
                      Payment ID
                    </th>
                    <th class="text-center">
                      Particulars
                    </th>
                    <th class="text-center">
                      Transfer Status
                    </th>
                    <th class="text-center">
                      Transfer ID
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in item.paymentTransfers" :key="list.id">
                    <td align="center" justify="center">{{ list.installmentAmount }}</td>
                    <td align="center" justify="center">{{ list.paymentID }}</td>
                    <td align="center" justify="center">{{ list.transactionDescription }}</td>
                    <td align="center" justify="center">{{ list.transferStatus }}</td>
                    <td align="center" justify="center">{{ list.transferID }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
      <v-row>
        <v-col class="text-right">
          <v-btn v-if="checkedRows.length > 0" depressed color="primary" @click="transferPayment()">Transfer</v-btn>
        </v-col>
      </v-row>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'

import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'

import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
  components: { MaterialCard },
  name: 'franchiseeOrderNodal',
  data () {
    return {
      PAYMENT_STATUS: [
        {
          text: 'INITIATED',
          value: 'INITIATED'
        },
        { text: 'FAILED', value: 'FAILED' },
        { text: 'CONFIRMED', value: 'CONFIRMED' },
        { text: 'APPROVAL_WAITING', value: 'APPROVAL_WAITING' },
        { text: 'TRANSFERRED', value: 'TRANSFERRED' }
      ],
      checkedRows: [],
      selectedStatus: 'TRANSFERRED',
      singleSelect: false,
      loadingComponent: null,
      companyName: '',
      modal: false,
      modal1: false,
      fromDate: moment(new Date())
        .subtract(1, 'month')
        .format('YYYY-MM-DD'),
      toDate: new Date().toISOString().substr(0, 10),
      expanded: [],
      singleExpand: true,
      inProgress: false,
      search: '',
      isLoading: false,

      franchiseeID: '',
      headers: [
        { text: 'Sr.No', sortable: true, value: 'index' },
        { text: 'Recipt No', sortable: true, value: 'receiptNo' },
        { text: 'status', value: 'status', sortable: true },
        { text: 'Order ID', value: 'orderID', sortable: true },

        { text: 'Enquiry Code', value: 'notes.enquiryCode', sortable: true },
        { text: 'Payment Status', value: 'paymentStatus', sortable: true },
        { text: 'Amount PTB', value: 'amountPTB', sortable: true },
        { text: 'Amount PTF', value: 'amountPTF', sortable: true },
        { text: 'Order Amount', value: 'amount', sortable: true },

        { text: 'Recipent', value: 'createdBy', sortable: true },
        { text: 'Created At', value: 'createdAt', sortable: true }
      ],
      tableData: []
    }
  },

  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    toDate: async function (val) {
      await this.onFranchiseeChange()
    },
    fromDate: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        Utils.helper.openDrawer(this, !this.franchiseeID)
        if (this.franchiseeID) {
          await this.onStart()
        }
        this.inProgress = false
      }
    },
    transferPayment: async function () {
      let that = this
      this.$buefy.dialog.confirm({
        message: 'Do you want to Transfer Payments',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async function () {
          try {
            let rowID = _.map(that.checkedRows, 'id')

            let response = ''
            if (rowID) {
              that.isLoading = true
              response = await http.post(`${constants.API_URL}/api/payments/transfer`, { orderID: rowID })

              that.isLoading = false
              that.checkedRows = []
            }

            if (response.data) {
              await that.onFranchiseeChange()
            }

            return that.$buefy.dialog.alert({
              type: 'is-success',
              message: 'Save successfully!',
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message

            console.log('error in  : ', errorMessage)
            that.checkedRows = []
            return that.$buefy.dialog.alert({
              type: 'is-danger',
              message: errorMessage,
              hasIcon: true,
              animation: 'zoom-out',
              size: 'is-medium',

              icon: ' mdi-exclamation',
              iconPack: 'mdi',
              ariaRole: 'alertdialog',
              ariaModal: true
            })
          } finally {
            that.isLoading = false
          }
        }
      })
    },
    onStart: async function () {
      if (!this.franchiseeID) {
        return this.$dialog.error({
          text: 'Please select Franchisee',
          title: 'Error'
        })
      }

      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/payments/orders?franchiseeID=${this.franchiseeID}&fromDate=${this.fromDate}&toDate=${this.toDate}&status=CONFIRMED`)
        this.tableData = data
        _.map(this.tableData, (obj, key) => {
          obj.index = key + 1

          obj.amount = Number(obj.amount / 100).toFixed(2)
          obj.amountPTB = Number(obj.amountPTB).toFixed(2)
          obj.amountPTF = Number(obj.amountPTF).toFixed(2)
          obj.createdAt = new Date(obj.createdAt).toLocaleString()
          obj.receiptNo = obj.receiptNo ? obj.receiptNo : 'N/A'

          obj.notes = obj.notes || {}
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
